var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCricket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/games/icon-cricket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb80c",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb80c",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb80c",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.9374768,7.16666667 C24.3265119,7.60541153 24.6809686,8.0736163 24.9976671,8.56708078 L24.2151457,9.33667773 L24.8966966,10.0053439 L25.4898984,9.39975944 C28.1329477,14.3040566 27.2454271,20.3606278 23.3062731,24.3011386 C19.3671191,28.2416494 13.3088186,29.1332917 8.40063924,26.4949047 L9.00646231,25.8893202 L8.33753267,25.220654 L7.55501121,25.990251 C7.0706563,25.6707365 6.60695347,25.3209894 6.16666667,24.9430945 Z M11.8588793,21.6880779 L10.0918953,23.454366 L10.760825,24.1230322 L12.5278089,22.3567441 L11.8588793,21.6880779 Z M5.69372691,6.6988614 C9.63288088,2.75835065 15.6911814,1.8667083 20.5993608,4.50509529 L19.9935377,5.11067977 L20.6624673,5.77934597 L21.4449888,5.00974902 C21.9293437,5.32926348 22.3930465,5.67901055 22.8333333,6.05690552 L5.06252324,23.8333333 C4.67348813,23.3945885 4.31903141,22.9263837 4.00233286,22.4329192 L4.78485433,21.6633223 L4.10330338,20.9946561 L3.51010162,21.6002406 C0.86705226,16.6959434 1.75457294,10.6393722 5.69372691,6.6988614 Z M15.3928472,18.1555017 L13.6258632,19.9217898 L14.3074142,20.590456 L16.0617768,18.8241679 L15.3928472,18.1555017 Z M7.63727129,17.4620799 L5.87028733,19.2409843 L6.53921698,19.9096505 L8.30620093,18.1433625 L7.63727129,17.4620799 Z M18.9268151,14.6355419 L17.1598311,16.3892137 L17.8287608,17.0578799 L19.5957447,15.3042081 L18.9268151,14.6355419 Z M11.1712392,13.9421201 L9.40425525,15.6957919 L10.0731849,16.3644581 L11.8401689,14.6107863 L11.1712392,13.9421201 Z M22.460783,11.1029658 L20.6937991,12.8566375 L21.3627287,13.5379201 L23.1297127,11.771632 L22.460783,11.1029658 Z M14.7052071,10.409544 L12.9382232,12.1758321 L13.6071528,12.8444983 L15.3615155,11.0782102 L14.7052071,10.409544 Z M18.2265537,6.87696784 L16.4721911,8.64325591 L17.1411207,9.31192211 L18.8954834,7.54563404 L18.2265537,6.87696784 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.0%",
    y: "-8.0%",
    width: "132.0%",
    height: "132.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/games/icon-cricket",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCricket);
export default __webpack_public_path__ + "static/media/icon-cricket.24730dfd4914333b0ea204c00a0376b4.svg";
export { ForwardRef as ReactComponent };